/* HARTLI PRODUCT SWATCH AJAX START */
(function () {
  function getMainProduct() {
    return document.querySelector('product-info[id^="MainProduct-"]');
  }

  function replaceIfFound(currentRoot, newRoot, selector) {
    const currentEl = currentRoot.querySelector(selector);
    const newEl = newRoot.querySelector(selector);

    if (currentEl && newEl) {
      currentEl.replaceWith(newEl);
    }
  }

  async function swapProduct(url) {
    const currentProduct = getMainProduct();
    if (!currentProduct) return false;

    const sectionId = currentProduct.dataset.section;
    const scrollY = window.scrollY;
    const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

    const response = await fetch(fetchUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) return false;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newProduct =
      doc.querySelector('product-info[id^="MainProduct-"]') ||
      doc.querySelector(`#MainProduct-${sectionId}`);

    if (!newProduct) return false;

    // Replace only key areas, not the whole product wrapper
    const newMedia = newProduct.querySelector('.product__media-wrapper');

    if (newMedia) {
    const imgs = newMedia.querySelectorAll('img');

    await Promise.all(
        [...imgs].slice(0, 3).map((img) => {
        return new Promise((resolve) => {
            const preload = new Image();

            preload.onload = resolve;
            preload.onerror = resolve;

            preload.src = img.currentSrc || img.src;
        });
        })
    );

    replaceIfFound(
        currentProduct,
        newProduct,
        '.product__media-wrapper'
    );
    }
// Update product-specific content
replaceIfFound(currentProduct, newProduct, '.product__title');
replaceIfFound(currentProduct, newProduct, '.metafield-rich_text_field');
replaceIfFound(currentProduct, newProduct, `[id="price-${sectionId}"]`);
replaceIfFound(currentProduct, newProduct, 'variant-selects');
replaceIfFound(currentProduct, newProduct, 'variant-radios');
replaceIfFound(currentProduct, newProduct, '.custom-color-swatches');
replaceIfFound(currentProduct, newProduct, '.product-form');
replaceIfFound(currentProduct, newProduct, '.product__description');

currentProduct.dataset.productId = newProduct.dataset.productId;
currentProduct.dataset.url = newProduct.dataset.url;

// Update complementary product
if (
  typeof window.hartliRefreshComplementary === 'function' &&
  newProduct.dataset.productId
) {
  window.hartliRefreshComplementary(
    newProduct.dataset.productId
  );
}

    window.history.pushState({ hartliProductAjax: true }, '', url);

    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });

    return true;
  }

  document.addEventListener(
    'click',
    async function (event) {
      const swatch = event.target.closest('.custom-color-swatches a.swatch');
      if (!swatch) return;

      const currentProduct = getMainProduct();
      if (!currentProduct) return;

      const url = swatch.getAttribute('href');
      if (!url) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      try {
        const ok = await swapProduct(url);
        if (!ok) window.location.href = url;
      } catch (error) {
        console.error('Hartli product swatch AJAX failed:', error);
        window.location.href = url;
      }
    },
    true
  );

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();
/* HARTLI PRODUCT SWATCH AJAX END */